import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import config from "@/config";
import main from "@/pages/main";
import login from "@/pages/login";
import logout from "@/pages/logout";
import pageEditor from "@/pages/pageEditor";
import ObjectView from "@/components/ObjectView";
import ObjectViewGraphView from "@/components/ObjectViewGraphView";

import pagePref from "@/pages/pagePref";
import OpenMetadata from "@/components/OpenMetadata";

import pageQuery from "@/pages/pageQuery";

import pageKazNIISA from "@/pages/pageKazNIISA";

import pageAstanaHUB from "@/pages/pageAstanaHUB";

import pageQuality from "@/pages/pageQuality";

//import pageTree from "./pages/pageTree";
//import pagePlayground from "./pages/pagePlayground";

import pageTest from "@/pages/pageTest";

const check = ( to, from, next ) => {
	if ( store.state.user.isLoggedIn ) {
		console.log( "authorization granted" );

		next();
		return;
	}
	
	console.log( "authorization failed, you will be redirected to login page" );
	next( { name: "login", params: { returnTo: to.fullPath }, replace: true } );

	//router.replace( { name: "protected", query: { err: "недостаточно прав для открытия данного ресурса" } } );
	//history.replaceState( {}, "Ошибка", cpURL );
	//next( { name: "login", params: { returnTo: to.fullPath }, replace: true } );
};

Vue.use( Router );

const editorRoute = {
  path:				"/editor/:endpoint/:classId",
  name:				"editor",
  beforeEnter:check,
  component:	pageEditor,
  children:		[
    {
      path: "/editor/:endpoint/:classId/object/:id",
      name: "objectView",
      components: {
        objectView: ObjectView
      },
      props: {
        objectView: true
      }/*,
      children:		[
        {
          path: "/editor/:endpoint/:classId/object/:id/graph",
          name: "objectViewGraphView",
          components: {
            objectViewGraphView: ObjectViewGraphView
          },
          props: {
            objectViewGraphView: true
          },
        }
      ]*/
    }
  ]
};

let router = new Router(
	{
		base:   config.client.path,
		mode:   "history",
		
		routes: [
			{
				path:		"/login",
				name:		"login",
				component:	login
			},
			
			{
				path:		"/logout",
				name:		"logout",
				component:	logout
			},
   
      {
        path: "/",
        redirect: "/editor"
      },
      
      editorRoute,
      {
        ...editorRoute,
        path: "/editor"
      },

      {
        path: "/test",
        component: pageTest
      },
/*
			{
				path:		"/",
				name:		"main",
				beforeEnter:check,
				component:	main
			},
*/
			
/*
			{
				path:		"/tree",
				name:		"tree",
				beforeEnter:check,
				component:	pageTree
			},

			{
				path:		"/playground",
				name:		"playground",
				beforeEnter:check,
				component:	pagePlayground
			},
*/

			{
				path:		"/quality/:endpoint/:classId",
				name:		"Quality",
				beforeEnter:check,
				component:	pageQuality
			},

			{
				path:		"/prefs",
				name:		"Preferences",
				beforeEnter:check,
				component:	pagePref,
				children:		[
					{
						path: "/prefs/openMetadata/:endpoint",
						name: "OpenMetadata",
						components: {
							OpenMetadata: OpenMetadata
						},
						props: {
							OpenMetadata: true
						}
					}
				]
			},

			{
				path:		"/query",
				name:		"Query",
				beforeEnter:check,
				component:	pageQuery
			},

			{
				path:		"/KazNIISA",
				name:		"KazNIISA",
				beforeEnter:check,
				component:	pageKazNIISA
			},

			{
				path:		"/AstanaHUB",
				name:		"AstanaHUB",
				beforeEnter:check,
				component:	pageAstanaHUB
			},

			{
				path:		"*",
				name:		"catchAll",
				beforeEnter:check,
				component:	main
			}
		]
	}
);

export default router;
